export const mod = (num, n) => (num % n + n) % n
